<template>
  <v-container class="grey-lighten-3 full-height">
    

    <!-- Printable Invoice Area -->
    <v-row justify="center">
      <v-col cols="12" xl="10" lg="11" md="12">
        <v-sheet
          class="invoice-paper pa-8 mx-auto"
          elevation="3"
          id="printable-area"
        >
          <!-- Header Section -->
          <div class="header-section d-flex justify-space-between mb-6 lines">
            <div class="company-logo-area d-flex align-center">
              <!-- Replace with actual logo -->
              <div class="logo-placeholder mr-4">
                <!-- <v-icon icon="mdi-domain" size="40" color="grey-darken-2"></v-icon> -->
              </div>
              <div>
                <v-img
                    :src="`${getFileServerUrl.replace(/\/$/, '')}/${voucherData?.company_logo || 'uploads/demo_images/user.png'}`"
                    width="200" height="100" class="rounded" />
              </div>
            </div>
            <div class="company-address text-caption text-right">
              <h1 class="company-name text-h5 font-weight-bold text-uppercase">
                {{ voucherData?.company_name }}
              </h1>
              <h1 class="text-subtitle-1">
                {{ voucherData?.company_address }}
              </h1>
            </div>
          </div>

          <!-- Title -->
          <div class="text-center mb-6">
            <h1
              class="report-title text-h6 font-weight-bold text-decoration-underline"
            >
              Credit Note Voucher
            </h1>
            <h2 class="text-h6 font-weight-bold">
              F Y - {{ voucherData?.financial_year }}
            </h2>
          </div>

          <!-- Voucher Meta Info -->
          <div class="meta-info-box mb-4">
            <div class="d-flex">
              <div
                class="meta-item d-flex align-center"
                style="width: 65%; border-right: 1px solid #000"
              >
                <span class="meta-label pl-2">Party Type:</span>
                <span class="meta-value pl-2 font-weight-bold">
                  {{ voucherData.party_type || "__________" }}
                </span>
              </div>
              <div
                class="meta-item d-flex align-center"
                style="width: 35%;"
              >
                <span class="meta-label pl-2">Voucher No:</span>
                <span class="meta-value pl-2 font-weight-bold">
                  {{ voucherData.voucher_no || "__________" }}
                </span>
              </div>
              
            </div>
            <div class="d-flex">
              <div
                class="meta-item d-flex align-center"
                style="width: 65%; border-right: 1px solid #000;"
              >
                <span class="meta-label pl-2">Party Name:</span>
                <span class="meta-value pl-2 font-weight-bold">
                  {{ voucherData.party_name || "__________" }}
                </span>
              </div>
               <div class="meta-item d-flex align-center" style="width: 35%">
                <span class="meta-label pl-2">Date:</span>
                <span class="meta-value pl-2 font-weight-bold">
                  {{ formattedDate(voucherData.voucher_date) }}
                </span>
              </div>
              
            </div>
            <div class="d-flex">
              <div class="meta-item d-flex align-center" style="width: 65%; border-right: 1px solid #000;">
                <span class="meta-label pl-2">Party ID:</span>
                <span class="meta-value pl-2 font-weight-bold">
                  {{ voucherData.party_code }}
                </span>
              </div>
             
              <div class="meta-item d-flex align-center" style="width: 35%">
                <span class="meta-label pl-2"></span>
                <span class="meta-value pl-2">
                  
                </span>
              </div>
            </div>
          </div>

          <!-- Accounts Table -->
          <div class="table-container mb-6">
            <table class="jv-table">
              <thead>
                <tr>
                  <th class="text-center" style="width: 40px">SL</th>
                  <th>Account Title & Description</th>
                  <th>Cost Center</th>
                  <th style="width: 100px">Account Code</th>
                  <th class="text-right" style="width: 110px">Debit</th>
                  <th class="text-right" style="width: 110px">Credit</th>
                  <th style="width: 150px">Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in voucherData.accounts" :key="index">
                  <td class="text-center">{{ index + 1 }}</td>
                  <td>
                    <div class="font-weight-medium">{{ row.account_name }}</div>
                  </td>
                  <td>
                    <div v-if="row.cost_center" class="font-weight-medium">
                      {{ row.cost_center }}
                    </div>
                  </td>
                  <td class="text-center">{{ row.account_code || "-" }}</td>
                  <td class="text-right">{{ formatNumber(row.debit) }}</td>
                  <td class="text-right">{{ formatNumber(row.credit) }}</td>
                  <td class="text-caption">{{ row.remarks }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="total-row">
                  <td colspan="4" class="text-right font-weight-bold pr-2">
                    Total (in word) : {{ voucherData?.amount_in_word }}
                  </td>
                  <td
                    class="text-right font-weight-bold text-decoration-underline"
                  >
                    {{ totalDebit }}
                  </td>
                  <td
                    class="text-right font-weight-bold text-decoration-underline"
                  >
                    {{ totalCredit }}
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <!-- Narration -->
          <div class="narration-section mb-8">
            <div class="font-weight-bold mb-1">Narration:</div>
            <div class="narration-content lines">
              {{
                voucherData.narration ||
                "__________________________________________________________________________________"
              }}
            </div>
          </div>

          <!-- Approvals -->
          <div class="approvals-section mb-8 mt-8">
            <h3 class="text-subtitle-1 font-weight-bold mb-2">Approval & Authorization</h3>
            <div class="approval-grid d-flex">

              <div class="approval-box">
                <div class="role-title">Prepared By</div>
                <div class="signature-line">
                  <span class="label">Name: <span class="font-weight-bold">{{ voucherData?.created_by?.full_name }}</span></span>
                </div>
                <div class="signature-line">
                  <span class="label">Signature:</span>
                   <img
                      v-if="voucherData?.created_by?.signature"
                      :src="baseURL+'/'+voucherData?.created_by?.signature"
                      class="signature-image"
                    />
                  
                </div>
                <div class="signature-line">
                  <span class="label">Date: <span class="font-weight-bold">{{ formattedDate(voucherData?.created_at) }}</span></span>
                </div>
              </div>

              <template v-if="voucherData?.approval_current_process">

                <template v-for="(approver, approvarIndex) in voucherData?.approval_process" :key="approvarIndex">

                  <div  class="approval-box" v-if="approver?.status?.toLowerCase() !== 'pending'">
                      <div class="role-title">{{ approvalTableHeadingTitle(approver) }}</div>
                      <div class="signature-line">
                        <span class="label">Name: <span class="font-weight-bold">{{ approver?.approved_by?.full_name }}</span></span>
                      </div>
                      <div class="signature-line">
                        <span class="label">Signature:</span>
                        <img
                            v-if="approver?.approved_by?.signature"
                            :src="baseURL+'/'+approver?.approved_by?.signature"
                            class="signature-image"
                          />
                      </div>
                      <div class="signature-line">
                        <span class="label">Date: <span class="font-weight-bold">{{ formattedDate(approver?.approved_at) }}</span></span>
                      </div>
                  </div>

                </template>

              </template>

              <div class="approval-box" v-if="!voucherData?.approval_current_process">
                <div class="role-title">Posted By</div>
                <div class="signature-line">
                  <span class="label">Name:</span>
                </div>
                <div class="signature-line">
                  <span class="label">Signature:</span>
                </div>
                <div class="signature-line">
                  <span class="label">Date:</span>
                </div>
              </div>

            </div>
          </div>

          <!-- Footer Note -->
          <!-- <div class="footer-note text-caption">
            <strong>Supporting Documents:</strong>
            <p class="ma-0">
              Attach relevant invoices, bills, or adjustment memos and approval
              note.
            </p>
          </div> -->
        </v-sheet>
      </v-col>
    </v-row>
    <!-- Action Toolbar (Hidden when printing) -->
    <v-row class="d-print-none mb-4" justify="center">
      <v-col cols="12" md="8" lg="9" class="d-flex justify-center gap-2">
        <!-- <v-btn color="primary" prepend-icon="mdi-printer" @click="printInvoice">
          Print Invoice
        </v-btn> -->
        <v-btn color="success" prepend-icon="mdi-download" @click="downloadPDF">
          Download PDF
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import html2pdf from 'html2pdf.js';
import approvalStatusLabel from "@/utils/approvalStatusLabel";
import { baseURL } from "@/store/api";
import formattedDate from '@/plugins/dateFormatter';

export default {
  name: "CreditNoteVoucherPrint",
  
  data() {
    return {
      baseURL,
      approvalStatusLabel,
      voucherData: {
        company_name: "",
        company_address: "",
        voucher_no: "",
        voucher_date: "",
        narration: "",
        accounts: []
      }
    };
  },

  computed: {
    totalDebit() {
      const sum = this.voucherData.accounts.reduce((acc, item) => acc + (Number(item.debit) || 0), 0);
      return sum > 0 ? sum.toFixed(2) : '0.00';
    },

    totalCredit() {
      const sum = this.voucherData.accounts.reduce((acc, item) => acc + (Number(item.credit) || 0), 0);
      return sum > 0 ? sum.toFixed(2) : '0.00';
    },
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl;
    },
  },

  methods: {
    formattedDate,
    
    approvalTableHeadingTitle(approver) {
      if (approver?.is_final_step == 1 && approver?.status?.toLowerCase() == 'approved') {
        return 'Posted By';
      }
      return this.approvalStatusLabel[approver?.status]?.label || '-';
    },
    // Transform API data to our format
    transformVoucherData(apiData) {
      return {
        company_name: apiData.branch?.company?.name || "Company Name",
        company_address: apiData.branch?.company?.address || "Company Address",
        company_logo: apiData?.branch?.company?.logo || "",
        financial_year: apiData.financial_year || "",
        amount_in_word: apiData.amount_in_word || "",
        voucher_no: apiData.code || "",
        voucher_date: apiData.voucher_date || "",
        narration: apiData.remarks || "",
        party_name:apiData.party?.party_name || "",
        party_type:apiData.party?.type || "",
        party_code:apiData.party?.code || "",

        approval_current_process: apiData.approval_current_process || null,
        approval_process: apiData.approval_process || null,
        created_by:apiData.created_by,
        created_at:apiData.created_at,
        
        accounts: apiData.voucher_items?.map(item => ({
          account_name: item.account_head?.name || "",
          account_code: item.account_head?.code || "",
          cost_center: item.cost_center ? `${item.cost_center.name} (${item.cost_center.code})` : null,
          debit: item.transaction_type === 'DEBIT' ? parseFloat(item.amount) : 0,
          credit: item.transaction_type === 'CREDIT' ? parseFloat(item.amount) : 0,
          remarks: item.remarks || ''
        })) || []
      };
    },

    // Process the data from your API response
    processVoucherData(data) {
      if (data && data.success && data.data) {
        this.voucherData = this.transformVoucherData(data.data);
      } else {
        console.error("Invalid voucher data format", data);
        // Set default data for testing
        this.voucherData = {
          company_name: "Demo Company Ltd.",
          company_address: "123 Business Street, Commercial Area, Dhaka - 1200",
          voucher_no: "JV-2024-001",
          voucher_date: new Date().toISOString().split('T')[0],
          narration: "Monthly adjustment entries for office expenses and revenue recognition",
          accounts: [
            {
              account_name: "Office Expenses",
              account_code: "51001",
              cost_center: "Administration (ADM001)",
              debit: 15000.00,
              credit: 0,
              remarks: "Monthly office supplies"
            },
            {
              account_name: "Accounts Payable",
              account_code: "21001",
              cost_center: null,
              debit: 0,
              credit: 15000.00,
              remarks: "Vendor payment due"
            }
          ]
        };
      }
    },

    async fetchInvoice(id) {
      try {
        const data = {
          slug: "credit-note-voucher",
          id: id
        };
        
        this.$store.dispatch("getVoucherById", data).then((invoiceData) => {
          console.log("Raw API Response:", invoiceData);
          this.processVoucherData(invoiceData);
          console.log("Processed voucher data:", this.voucherData);
        });
      } catch (error) {
        console.error("Failed to load invoice:", error);
      }
    },

    formatNumber(num) {
      if (!num || num === 0) return '0.00';
      return Number(num).toFixed(2);
    },

    printInvoice() {
      // Create a copy of the printable area
      const printContent = document.getElementById('printable-area').cloneNode(true);
      
      // Create a new window for printing
      const printWindow = window.open('', '_blank', 'width=1000,height=600');
      
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Credit Note Voucher - ${this.voucherData.voucher_no}</title>
            <style>
              body {
                margin: 0;
                padding: 15px;
                font-family: 'Times New Roman', serif;
                background: white;
                color: black;
              }
              
              .invoice-paper {
                width: 100%;
                max-width: none;
                margin: 0;
                padding: 20px;
                box-shadow: none;
              }
              
              .company-name {
                letter-spacing: 1px;
                color: #444;
              }
              
              .report-title {
                text-decoration: underline;
                text-underline-offset: 4px;
              }
              
              .meta-info-box {
                border: 1px solid #000;
              }
              
              .meta-item {
                height: 35px;
              }
              
              .jv-table {
                width: 100%;
                border-collapse: collapse;
                font-size: 14px;
              }
              
              .jv-table th {
                background-color: #e0e0e0;
                font-weight: bold;
                padding: 8px 5px;
                border: 1px solid #000;
              }
              
              .jv-table td {
                padding: 8px 5px;
                border: 1px solid #000;
                vertical-align: top;
                height: 35px;
              }
              
              .lines {
                border-bottom: 1px solid #ccc;
                min-height: 60px;
                padding: 5px 0;
                white-space: pre-wrap;
                line-height: 1.5;
              }
              
              .approval-grid {
                border: 1px solid #000;
              }
              
              .approval-box {
                border-right: 1px solid #000;
                min-height: 120px;
              }
              
              .role-title {
                background-color: #e0e0e0;
                padding: 4px 8px;
                font-weight: bold;
                font-size: 13px;
                border-bottom: 1px solid #000;
              }
              
              .signature-line {
                padding: 8px;
                font-size: 12px;
              }
              
              @media print {
                body {
                  margin: 0;
                  padding: 0;
                }
                .invoice-paper {
                  padding: 15px;
                }
                @page {
                  margin: 0.5cm;
                  size: A4;
                }
              }
            </style>
          </head>
          <body>
            <div class="invoice-paper">
              ${printContent.innerHTML}
            </div>
            <script>
              window.onload = function() {
                window.print();
                setTimeout(() => window.close(), 500);
              };
            <\/script>
          </body>
        </html>
      `);
      
      printWindow.document.close();
    },

    async downloadPDF() {
      const element = document.getElementById('printable-area');
      const opt = {
        margin: [0.5, 0.5],
        filename: `credit-note-voucher-${this.voucherData.voucher_no}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { 
          scale: 2,
          useCORS: true,
          logging: false
        },
        jsPDF: { 
          unit: 'cm', 
          format: 'a4', 
          orientation: 'portrait' 
        }
      };

      try {
        await html2pdf().set(opt).from(element).save();
      } catch (error) {
        console.error('PDF generation failed:', error);
        // Fallback to print if PDF generation fails
        this.printInvoice();
      }
    }
  },

  mounted() {
    console.log("Current route:", this.$route.fullPath);
    const invoiceId = this.$route.params.id;
    
    if (invoiceId) {
      console.log("Fetching invoice for ID:", invoiceId);
      this.fetchInvoice(invoiceId);
    } else {
      console.error("No invoice ID found in route params");
    }
  }
};
</script>

<style scoped>
.signature-image {
  width: 50px;
  height: auto;
  margin-left: 8px;
}
/* --- Screen-only Styles --- */
.full-height {
    min-height: 100vh;
}
.grey-lighten-3 {
    background-color: #eeeeee !important;
}

/* --- Extended Width Invoice Paper --- */
.invoice-paper {
  background-color: white;
  color: black;
  font-family: 'Times New Roman', serif;
  max-width: 280mm; /* Extended width */
  width: 100%;
  min-height: 297mm; /* A4 height */
}

.company-name {
    letter-spacing: 1px;
    color: #444;
}

.report-title {
    text-decoration: underline;
    text-underline-offset: 4px;
}

/* Meta Info Box */
.meta-info-box {
    border: 1px solid #000;
}
.meta-item {
    height: 35px;
}
.meta-label {
    font-weight: normal;
    color: #333;
}

/* Extended Table Styles */
.jv-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    table-layout: fixed;
}
.jv-table th {
    background-color: #e0e0e0;
    font-weight: bold;
    text-align: left;
    padding: 8px 5px;
    border: 1px solid #000;
}
.jv-table td {
    padding: 8px 5px;
    border: 1px solid #000;
    vertical-align: top;
    height: 35px;
    word-wrap: break-word;
}
.jv-table .total-row td {
    background-color: #f9f9f9;
}

/* Narration */
.narration-content {
    border-bottom: 1px solid #ccc;
    min-height: 60px;
    padding: 5px 0;
    white-space: pre-wrap;
    line-height: 1.5;
}

.lines {
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
}

/* Approval Grid */
.approval-grid {
    border: 1px solid #000;
}
.approval-box {
    flex: 1;
    border-right: 1px solid #000;
    min-height: 120px;
    display: flex;
    flex-direction: column;
}
.approval-box:last-child {
    border-right: none;
}
.role-title {
    background-color: #e0e0e0;
    padding: 4px 8px;
    font-weight: bold;
    font-size: 13px;
    border-bottom: 1px solid #000;
}
.signature-line {
    flex: 1;
    padding: 8px;
    display: flex;
    align-items: flex-end;
    font-size: 12px;
}
.signature-line .label {
    margin-right: 5px;
    min-width: 40px;
}
.signature-line::after {
    content: '';
    flex: 1;
    border-bottom: 1px dotted #999;
    margin-bottom: 2px;
}

/* Footer Note */
.footer-note {
    font-size: 12px;
    color: #555;
}

/* Gap utility for buttons */
.gap-2 {
    gap: 8px;
}

/* --- PRINT SPECIFIC CSS --- */
@media print {
  /* Hide everything except the printable area */
  body * {
    visibility: hidden;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  #printable-area, 
  #printable-area * {
    visibility: visible;
  }
  
  #printable-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    max-width: 100%;
    padding: 15px !important;
    margin: 0 !important;
    box-shadow: none !important;
  }

  /* Remove Vuetify container styles for print */
  .v-container, 
  .v-row, 
  .v-col, 
  .v-sheet {
    background-color: white !important;
    box-shadow: none !important;
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: none !important;
  }

  /* Ensure colors print correctly */
  .jv-table th, 
  .role-title,
  .total-row td {
    background-color: #e0e0e0 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    color-adjust: exact;
  }

  /* Hide toolbar and action buttons */
  .d-print-none {
    display: none !important;
    visibility: hidden !important;
  }

  /* Force borders to print */
  .jv-table,
  .jv-table th,
  .jv-table td,
  .meta-info-box,
  .approval-grid,
  .approval-box {
    border-color: #000 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  /* Page setup */
  @page {
    size: A4 landscape; /* Landscape for extended width */
    margin: 0.5cm;
  }

  /* Prevent page breaks inside important sections */
  .jv-table,
  .approval-grid,
  .narration-section {
    page-break-inside: avoid;
  }

  /* Ensure proper spacing */
  .invoice-paper {
    padding: 20px !important;
    max-width: 100% !important;
  }

  /* Text styling for print */
  .company-name,
  .report-title {
    color: #000 !important;
  }
}

/* Responsive adjustments for screen view */
@media screen and (max-width: 1280px) {
  .invoice-paper {
    max-width: 100%;
    padding: 20px !important;
  }
}

@media screen and (max-width: 960px) {
  .invoice-paper {
    padding: 15px !important;
  }
  
  .jv-table {
    font-size: 12px;
  }
  
  .jv-table th,
  .jv-table td {
    padding: 6px 4px;
  }
}

@media screen and (max-width: 600px) {
  .invoice-paper {
    padding: 10px !important;
  }
  
  .header-section {
    flex-direction: column !important;
    gap: 15px;
  }
  
  .company-address {
    text-align: left !important;
  }
  
  .approval-grid {
    flex-wrap: wrap;
  }
  
  .approval-box {
    min-width: 50%;
    border-bottom: 1px solid #000;
  }
}
</style>